<template>
  <div class="launchpack-delivery">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    ></admin-filter>

    <div class="flex space-between">
      <div class="flex">
        <div class="basic-tab" :class="{'tab-selected': selectedTab===0}" @click="selectedTab=0">주문번호별</div>
        <div class="basic-tab" :class="{'tab-selected': selectedTab===1}" @click="selectedTab=1">상품주문번호별</div>
      </div>

      <div>
        <button class="button" style="width:160px" @click="downloadSample">송장 엑셀 다운로드</button>
        <button class="button" style="width:160px;margin-left:8px" @click="openUploadModal">송장번호 일괄등록하기</button>
        <button class="button is-primary" style="margin-left:8px" @click="saveInvoice">송장번호 저장</button>
      </div>
    </div>

    <!-- 탭 1 -->
    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength" v-if="selectedTab===0">
      <td slot="checkspot" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">
        <div @click="clickDetail(`${props.item.order.id}&page=OrderListDeliveryNew`)" style="cursor:pointer;font-weight:bold">{{ props.item.order.order_num }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.name }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div class="flex align-center">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px" v-if="props.item.product.img">
          <div style="text-align: left">
            <div v-if="props.item.order_product_option.length>0">
              <div>{{ props.item.product.name }}</div>
              <div
                v-for="(option, option_idx) in props.item.order_product_option"
                :key="'option-'+option_idx">
                <span v-if="option.option.option_type===0">기본옵션:</span>
                <span v-if="option.option.option_type===1">추가옵션:</span>
                {{ optionFullName(option) }}
              </div>
            </div>
            <div v-else>
              {{ props.item.product.name }}
            </div>
          </div>
        </div>
      </td>

      <!-- 배송 금액 -->
      <td slot="delivery_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.delivery_cost | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.total_price | currency }}</td>

      <!-- 포인트 -->
      <td slot="point" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.point | currency }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type }}</span></td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리</button>
        </div>
      </div>
    </order-table>

    <!-- 탭 2 -->
    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 :table_width="2200"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength" v-if="selectedTab===1">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(`${props.item.order.id}&page=OrderListDeliveryNew`)" style="cursor:pointer;font-weight:bold">{{ props.item.id }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.name }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div class="flex align-center">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px" v-if="props.item.product.img">
          <div style="text-align: left">
            <div v-if="props.item.order_product_option.length>0">
              <div>{{ props.item.product.name }}</div>
              <div
                v-for="(option, option_idx) in props.item.order_product_option"
                :key="'option-'+option_idx">
                <span v-if="option.option.option_type===0">기본옵션:</span>
                <span v-if="option.option.option_type===1">추가옵션:</span>
                {{ optionFullName(option) }}
              </div>
            </div>
            <div v-else>
              {{ props.item.product.name }}
            </div>
          </div>
        </div>
      </td>

      <!-- 수량 -->
      <td slot="quantity" slot-scope="props">{{ props.item.quantity }}</td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배송 금액 -->
      <td slot="delivery_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.delivery_cost | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.total_price | currency }}</td>

      <!-- 포인트 -->
      <td slot="point" slot-scope="props">{{ props.item.point | currency }}</td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props">
        <div v-if="props.item.partner">{{ props.item.partner }}</div>
        <div v-else>-</div>
      </td>

      <!-- 주문 상태 -->
      <td slot="status_kor" slot-scope="props">{{ props.item.status_kor }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type }}</span></td>

      <!-- 상태 변경 -->
      <td slot="status_change" slot-scope="props">
        <button class="button" @click="statusChange(props.item.id, 301)">배송중 처리</button>
      </td>

      <!-- 택배사 -->
      <td slot="delivery_company" slot-scope="props">
        <span class="select">
          <select v-model="props.item.delivery_company"
                  @change="e=> selectDeliveryCompany(e, props.item)">
            <option value="" disabled selected>선택</option>
            <option :value="item.value"
                    v-for="item in deliveryArr" :key="item.label">{{ item.label }}</option>
          </select>
        </span>
      </td>

      <!-- 송장번호 -->
      <td slot="invoice" slot-scope="props">
        <input class="input"
               :value="props.item.invoice"
               @input="e => props.item.invoice = e.target.value"
               @keyup.enter="saveSingleInvoice(props.item)"
               placeholder="송장번호 입력"
               type="number">
      </td>

      <!-- 배송 정보 -->
      <td slot="delivery_info" slot-scope="props" style="position:relative">
        <div class="delivery-section" style="cursor: pointer">
          <i class="material-icons">library_books</i>
          <div class="delivery-info">
            <div style="display:inline-block;width:30%">수령자</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.name }}</div>
            <div style="display:inline-block;width:30%">휴대전화</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.tphone }}</div>
            <div style="display:inline-block;width:30%">일반전화</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.phone }}</div>
            <div style="display:inline-block;width:30%">주소</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.address }}</div>
            <div style="display:inline-block;width:30%">배송메시지</div>
            <div style="display:inline-block;width:70%">{{ props.item.order.delivery.memo }}</div>
          </div>
        </div>
      </td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리</button>
        </div>
      </div>
    </order-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <!-- 송장 파일 업로드 -->
    <modal name="invoiceModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div v-if="invoice_tab===1">
          <div>
            <input type="file" id="file"
                   ref="files"
                   @change="handleFileUpload"
                   :accept="acceptExt">
          </div>
          <div class="flex justify-center">
            <button class="button is-primary" @click="upload">업로드하기</button>
          </div>
        </div>
        <div v-else-if="invoice_tab===2">
          <span>성공한 횟수: {{ success_count }}</span>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import DeliveryMixin from "@/mixins/DeliveryMixin"

  export default {
    name: 'order-list-pickup-new',
    components: {LpCheckBool},
    mixins: [
      DeliveryMixin
    ],
    created() {
      // (테이블 필드, 사용할 api, 현재페이지)
      this.initializing('delivery_new_tab2', 'delivery/orderproduct?status=300', 'OrderListDeliveryNew');
      this.getDeliveryCompany();
    },
    data() {
      return {
        // 배송업체 목록
        deliveryArr: [],
        acceptExt: '.xlsx',
        file: '',
        success_count: '',
        invoice_tab: 1
      }
    },
    watch: {
      selectedTab(n){
        if(this.selectedTab===0){
          this.initializing('delivery_new_tab1', 'delivery/orderproduct?status=300', 'OrderListDeliveryNew');
        }
        if(this.selectedTab===1){
          this.initializing('delivery_new_tab2', 'delivery/orderproduct?status=300', 'OrderListDeliveryNew');
        }
      }
    },
    methods: {
      // 송장 엑셀 샘플 파일 다운로드
      downloadSample() {
        this.$axios.get(this.getUrl(`delivery/invoice/download`), {
          responseType: 'arraybuffer',
        }).then(response=> {
          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var blobURL = window.URL.createObjectURL(blob);
          var tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', 'sample.xlsx');
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        })
      },
      // 송장 엑셀 파일 업로드
      upload() {
        if(!this.file) return;
        let formData = new FormData();

        formData.append('file', this.file);
        console.log(formData)

        this.$axios.post(this.getUrl('delivery/invoice/upload'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(res => {
            if (res.status === 200) {
              this.toast('업로드 되었습니다.');
              this.success_count = res.data.success_count;
              this.invoice_tab = 2;
              this.$refs.files.value = "";
              this.getData();
            }
          })
          .catch(error => {
            //console.log(error);
            this.toast('등록된 형식의 문서가 아닙니다.');
            this.$refs.files.value = "";
          });
      },
      // 파일 선택
      handleFileUpload() {
        this.file = this.$refs.files.files[0];

        if (this.file.size > 115343360) {
          this.toast('최대 10MB 파일까지만 업로드 가능합니다.');
          return;
        }
      },
      // 업로드 팝업 열기
      openUploadModal(){
        this.$modal.show('invoiceModal');
        this.invoice_tab = 1;
      },
      getDeliveryCompany() {
        this.$axios.get('public/delivery/delivery_company').then(res=> {
          this.deliveryArr = res.data;
        })
      },
      selectDeliveryCompany(e, item) {
        item.delivery_company = e.target.value;
        this.$axios.post(this.getUrl(`delivery/orderproduct/${item.id}/invoice/update`), {
          invoice: item.invoice,
          delivery_company: item.delivery_company
        }).then(()=> {})
      },
      saveSingleInvoice(item) {
        console.log(item.invoice)
        this.$axios.post(this.getUrl(`delivery/orderproduct/${item.id}/invoice/update`), {
          invoice: item.invoice,
          delivery_company: item.delivery_company
        }).then(()=> {})
      },
      saveInvoice() {
        let check_list = this.getCheckedArr();
        if(check_list.length===0) {
          this.toast('송장번호를 입력했다면, 체크박스를 선택해주세요.');
          return;
        }
        let params = []
        this.tableItems.forEach(item=> {
          if(check_list.indexOf(item.id)>-1) {
            params.push({id: item.id, delivery_company: item.delivery_company, invoice: parseInt(item.invoice)})
          }
        })
        this.$axios.post(this.getUrl('delivery/orderproduct/invoice/update'), {
          params: params
        }).then(res=>{
          if(res.status===200) {
            this.toast('송장번호가 저장되었습니다.')
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb

  .delivery-info
    position absolute
    left -170px
    top 38px
    background #eee
    z-index 10
    padding 8px
    width 240px

  .delivery-info
    display none

  .delivery-section:hover .delivery-info
    display block
</style>
